import React from 'react';

const categories = [
  { id: '', label: 'All' },
  { id: 'sans-serif', label: 'Sans-serif' },
  { id: 'serif', label: 'Serif' },
  { id: 'display', label: 'Display' },
  { id: 'handwriting', label: 'Handwriting' },
  { id: 'monospace', label: 'Monospace' },
];

export function FontCategoryTabs({ value, onChange }) {
  return (
    <div className="mp-font-picker-tabs" role="tablist" aria-label="Categorias de fonte">
      {categories.map((category) => (
        <button
          key={category.id || 'all'}
          type="button"
          role="tab"
          aria-selected={value === category.id}
          className={`mp-font-picker-tabs__item ${value === category.id ? 'is-active' : ''}`}
          onClick={() => onChange(category.id)}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}

export default FontCategoryTabs;
